import api from './axiosConfig';

export const mailApi = {
  // Create a new draft
  createDraft: (data) => api.post('/v1/mail/draft', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Update existing draft
  updateDraft: (id, data) => api.put(`/v1/mail/draft/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Send email (can pass draftId or new mail data)
  sendMail: (data) => api.post('/v1/mail/send', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Get mails by folder (inbox, sent, drafts, trash, archive, starred)
  getMailsByFolder: (folder) => api.get(`/v1/mail/folder/${folder}`),
  
  // Get single mail details
  getMailDetails: (id) => api.get(`/v1/mail/${id}`),
  
  // Update status (e.g., move to trash, archive)
  updateStatus: (id, status) => api.put(`/v1/mail/${id}/status`, { status }),
  
  // Toggle Star
  toggleStar: (id) => api.put(`/v1/mail/${id}/star`),
  
  // Permanent Delete
  deleteMail: (id) => api.delete(`/v1/mail/${id}`),
  
  // AI Assist
  aiAssist: (action, text, context) => api.post('/v1/mail/ai-assist', { action, text, context }),

  // Templates
  saveTemplate: (data) => api.post('/v1/mail/template', data),
  getTemplates: () => api.get('/v1/mail/templates'),
  deleteTemplate: (id) => api.delete(`/v1/mail/template/${id}`)
};
